import { ClassSubjectDef } from './subject-def';


export const callback = (target: any, propertyKey: PropertyKey) => {
	ClassSubjectDef
		.getOrMakeFor(target.constructor)
		.addCallback(propertyKey);
};